// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__26K4K","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__2SD9z"};